import {FC} from "react";
import {useDescriptionTimer} from "modules/utils";
import {PageDesc} from "./Page";

export const PageDescriptionWithTimer: FC = () => {
	const desc = useDescriptionTimer();

	return <PageDesc>{desc}</PageDesc>;
};
